import React, {FunctionComponent, useState} from "react";
import {Collapse} from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import {theme} from "/src/assets/theme";
import {
    ChallengeFormula,
    DsqRecord,
    instanceOfTeamRecord,
    ProtocolRecord,
    SingleRaceRecord,
    TeamRaceRecord
} from "/src/domain/challenges/ChallengeProtocolData";
import {RecordView} from "./RecordView";
import {RecordViewInfo} from "./RecordViewInfo";
import {User} from "/src/domain/shared/User";

export type ExpandableRecordViewProps = {
    placeByOrder?: number;
    record: ProtocolRecord,
    isDefaultExpanded?: boolean,
    currentUser?: User,
    challengeType: ChallengeFormula
}

export const ExpandableRecordView: FunctionComponent<ExpandableRecordViewProps> = ({
                                                                                       placeByOrder,
                                                                                       record,
                                                                                       challengeType,
                                                                                       currentUser,
                                                                                       isDefaultExpanded = false
                                                                                   }) => {
    const [isExpanded, expand] = useState(isDefaultExpanded || isCurrentUserInProtocol(record, currentUser));
    const classes = useStyles();

    return (
        <div onClick={() => {
            expand(!isExpanded)
        }} className={classes.container}>
            <RecordView
                placeByOrder={placeByOrder}
                currentUser={currentUser}
                record={record}
                isExpanded={isExpanded}
                challengeType={challengeType}
                isCurrentUserParticipant={isCurrentUserInProtocol(record, currentUser)}
                isFull={instanceOfTeamRecord(record) && Boolean(record.result)}/>
            <Collapse in={isExpanded}>
                <RecordViewInfo record={record as TeamRaceRecord | SingleRaceRecord | DsqRecord}
                                challengeType={challengeType} isExpanded={isExpanded}/>
            </Collapse>
        </div>

    );
}

const isCurrentUserInProtocol = (record: ProtocolRecord, currentUser?: User): boolean => {
    if (instanceOfTeamRecord(record))
        return record.records.find(r => r.participant.id === currentUser?.id) !== undefined;

    return (record as SingleRaceRecord).participant.id === currentUser?.id;
}

const useStyles = makeStyles({
    container: {
        color: theme.primaryColor,
        '&:nth-child(even)': {
            backgroundColor: theme.lightPrimaryColor
        },
    }
})

